export default __webpack_public_path__ + "static/media/ca-1-rMAX.7cf4f15d.avif";